import React from "react"
import { FormattedMessage } from "react-intl"
import { Heading } from "@walmart-web/livingdesign-components"
import { collapseSideBar } from "context/applicationContext"
import ContextualHeader from "components/Shared/ContextualHeader"
import NavTabs from "components/Shared/NavTabs"
import { BREADCRUMBS, TabsOptions } from "components/UserManagement/constants"
import "./index.scss"

const Administration: React.FC = () => {
	collapseSideBar()

	return (
		<div className="user-managament">
			<ContextualHeader breadcrumbs={BREADCRUMBS} />
			<Heading UNSAFE_className="header" as="h1">
				<FormattedMessage id="phronesis.usermanagement" />
			</Heading>

			<NavTabs className="navTabs" tabs={TabsOptions} />
		</div>
	)
}

export default Administration
